import { Dropdown } from '@app/models/interfaces/Dropdown';

export function makeDropdownOption(value: string, label: string, availability: string): Dropdown {
    return {
        value: value,
        label: label,
        availability: availability
    };
}
